import React from "react";
import { SignUp } from "@clerk/clerk-react";
import { useLocation } from "react-router-dom";
import { getRedirectUrl } from "components/utils/getRedirectUrl";
import { getAllNestedParams } from "components/utils/getNestedQueryParams";
import { Role } from "types";

const SignUpWithClerk: React.FC = () => {
  const { hash } = useLocation();
  const signInUrl = getRedirectUrl("/sign-in");

  const searchString = hash.replace(/^#\/?/, "");

  const outerUrl = new URL(searchString, window.location.origin);
  const redirectUrlEncoded = outerUrl.searchParams.get("redirect_url");
  const viaParam = outerUrl.searchParams.get("via");

  const nestedParams = redirectUrlEncoded
    ? getAllNestedParams(searchString, "redirect_url")
    : {};

  const appParam = nestedParams.app;

  const validRoles = Object.values(Role);
  const roles = validRoles.includes(appParam as Role) ? [appParam] : validRoles;

  if (!validRoles.includes(appParam as Role)) {
    console.log("Invalid or missing app param, defaulting roles to all roles.");
  }

  return (
    <div className="flex justify-center items-center min-h-[100vh] z-[9999]">
      <SignUp
        appearance={{
          elements: {
            cardBox: "w-[100%] sm:w-[70%] md:w-[40vw] max-w-[80vw]",
            headerSubtitle: "text-gray-800",
            formButtonPrimary:
              "bg-primary-700 hover:bg-primary-700 font-bold rounded-md px-4 py-2",
            identityPreviewText: "text-gray-700 font-normal",
            footerActionLink:
              "text-primary-700 hover:text-primary-800 font-semibold",
            footerActionText: "text-gray-600 font-normal",
          },
        }}
        signInUrl={signInUrl}
        unsafeMetadata={{
          roles,
          isHarbourClub: viaParam === "harbour",
          isBiz4Biz: viaParam === "isBiz4Biz",
        }}
      />
    </div>
  );
};

export default SignUpWithClerk;
